import React from "react";
import { NavDropdown } from "react-bootstrap";

// This component is a menu collection of actions related to selecting a theme for the Ag-Grid
function ThemeSelector(props) {
  const { gridApi, setGridTheme } = props;

  const setTheme = (theme) => {
    setGridTheme(theme);
    setTimeout(() => {
      gridApi.resetRowHeights();
      // there is a `useEffect` in `Grid.js` that
      // updates column heights when `gridTheme` is updated.
    }, 300);
  };

  return (
    <NavDropdown title="Theme" id={"nav-bar-theme"}>
      <NavDropdown.Item onClick={() => setTheme("ag-theme-balham")}>
        Balham
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => setTheme("ag-theme-alpine")}>
        Alpine
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => setTheme("ag-theme-fresh")}>
        Fresh
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => setTheme("ag-theme-blue")}>
        Blue
      </NavDropdown.Item>
    </NavDropdown>
  );
}

export default ThemeSelector;
